import { framing, worldFraming } from './framing';
import type { SceneDriver, SceneTransform } from './types';

const out: SceneTransform = {
  framing: framing(),
  scale: 1,
  yaw: 0,
  pitch: 0,
};

export const staticDriver: SceneDriver = ({ viewport, channels }) => {
  channels.morph.current = 1;
  channels.coastlineOpacity.current = 1;
  channels.timezoneOpacity.current = 1;
  channels.dotReveal.current = 1;
  worldFraming(viewport, out.framing);
  return out;
};
